import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import LinkedInCallback from '../../features/auth/components/LinkedInCallback';

const LinkedInCallbackRoute = () => {
  return (
    <ProtectedRoute requiresAuth={false}>
      <LinkedInCallback />
    </ProtectedRoute>
  );
};

export default LinkedInCallbackRoute;
